import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CloudStorageService } from '~/api/services/cloudStorage'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import { FileData } from '..'

interface DeleteFileModalProps {
  files: {
    rows: FileData[]
  }
  singleDeleteFile: FileData
  checkedFiles: string[]
  openDeleteFilesModal: boolean
  handleClose: () => void
  handleSubmit: () => void
}

const DeleteFileModal:React.FC<DeleteFileModalProps> = (props) => {
  const { t } = useTranslation()
  const {
    files,
    singleDeleteFile,
    checkedFiles,
    openDeleteFilesModal,
    handleClose,
    handleSubmit
  } = props

  const [isBusy, setIsBusy] = useState(false)

  const namesOfDeletedFiles = []
  if (singleDeleteFile) {
    namesOfDeletedFiles.push(singleDeleteFile.title)
  } else {
    checkedFiles.map((checkeFileId) => {
      const name = files?.rows.find(file => checkeFileId === file.id).title
      namesOfDeletedFiles.push(name)
    })
  }

  async function handleDeleteFiles() {
    setIsBusy(true);
    try {
      await CloudStorageService.deleteFiles({ fileIds: singleDeleteFile ? [singleDeleteFile?.id] : [...checkedFiles] })
      handleSubmit()
      if (singleDeleteFile) {
        notify(t('File successfully deleted'), 'success')
      } else {
        notify(t('Files successfully deleted'), 'success')
      }
    } catch (error) {
      if (error?.response?.data) {
        notify(error?.response?.data?.message, 'error');
      } else {
        notify(t('General error'), 'error');
      }
    }
    setIsBusy(false);
  }

  return <Dialog
    open={openDeleteFilesModal}
    handleClose={() => handleClose()}
    isLoading={isBusy}
    handleSubmit={() => handleDeleteFiles()}
    textHeader={t('Delete confirmation')}
    textContent={t('Do you really want to delete files: {{namesOfDeletedFiles}}', { namesOfDeletedFiles: namesOfDeletedFiles.toString() })}
    textClose={t('Close')}
    textSubmit={t('Delete')}
    type={'abort'}
  />
}
export default DeleteFileModal